export default __webpack_public_path__ + "6059d691b0223afc6cc5b25c7d307418.ttf";